import { checkDiff } from '../../../../../utils/formValidation/errorCheckingFunctions';

import { validateFrequencyId, validateIwsEventOwnerId } from './validationFunctions';

export const validate = (newEntry, initialData) => {
    let newErrors = {};

    newErrors = validateFrequencyId(newEntry.frequencyId, newErrors);
    newErrors = validateIwsEventOwnerId(newEntry.iwsEventOwnerId, newErrors);

    if (newEntry?.id && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialData);

    return newErrors;
};
